export const yr2022 = {
    zelfstandigenaftrek: 6310,
    startersaftrek: 2123,
    mkbVrijstelling: 14,
    zvwBijdrage: { pct: 5.50, limit: 59706 },
    arbeidskorting: [
        { low: 0, high: 10351, pct: 4.541, addition: 0 },
        { low: 10351, high: 22357, pct: 28.461, addition: 470 },
        { low: 22357, high: 36650, pct: 2.610, addition: 3887 },
        { low: 36650, high: 109347, pct: -5.860, addition: 4260 },
        { low: 109347, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 69399, pct: 37.07, addition: 0 },
        { low: 69399, high: 999999999, pct: 49.50, addition: 25725 },
    ],
    heffingskorting: [
        { low: 0, high: 21318, pct: 0, addition: 2888 },
        { low: 21318, high: 69398, pct: -6.007, addition: 2888 },
        { low: 69398, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 69399,
    tarrifaanpassing: 0.0950,
}